.tile {

    border-radius: var(--border-radius);
    overflow: hidden;
    display: flex;
    position: relative;


    .article {

        display: block;
        background-color: white;
        transition: background-color 0.25s;

        &:hover {
            background-color: var(--beige);
        }
        .header {

            position: relative;
            height: 200px;
            width: 100%;

            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                overflow: hidden;
            }

          &.headerNoImage {
            background-color: #e5e5e5;
            overflow: hidden;
          }
            // Mensenlinq shape
            svg.shape {
              position: absolute;
              height: 100%;
              width: auto;


              right: 54px;
              transform: scale(1.55);

              path {
                //fill: #767676;
                fill: var(--beigedarker);
                opacity: .3;
              }
            }
        }

        .content {
            padding: 30px;
            color: black;

            h2 {
                margin: 0 0 20px 0;
            }
        }
    }

  .tags {
    position: absolute;
    top: 20px;
    left: 20px;
    display: flex;
    gap: 1.25em;

    .tag {
      border-radius: var(--border-radius);
      padding: 5px 15px;

      background-color: white;
      color: black;
      transition-property: color, background-color;
      transition-duration: 0.25s;

      &:hover
      {
        background-color: var(--beigedark);
        color: white;
      }
    }
  }



}
